@if (hasDrugResults) {
  @if (!showLoadingIndicator) {
    <div class='individual-drugs'>
      <div class='coverage-container'>
        @if (numCoveredDrugs === numTotalDrugs) {
          <span class="material-symbols-outlined covered-drug">check_circle_outline</span>
        }
        @if (numCoveredDrugs > 0 && numCoveredDrugs < numTotalDrugs) {
          <span class="material-symbols-outlined partial-covered-drug">warning
          </span>
        }
        @if (numCoveredDrugs === 0) {
          <span class="material-symbols-outlined not-covered-drug">highlight_off</span>
        }
        <span class="coverage-text">Prescription Coverage ({{numCoveredDrugs}} of {{numTotalDrugs}})</span>
      </div>
      <button mat-button color="primary" (click)="showMedicalDetails()">
        Show Medication Details
      </button>
    </div>
  } @else {
    <div class="spinner-container">
      <mat-spinner [diameter]="25"></mat-spinner>
    </div>
  }
}